// Start aplikacji z ekranu telefonu (tryb standalone):
// - po otwarciu pokazujemy ekran szybkiego wyboru (/start), raz na uruchomienie
//   i tylko gdy nie został wyłączony; bez niego — rozmowa z asystentem;
// - iOS nie odświeża start_url z manifestu, więc telefony zainstalowane wcześniej
//   (start_url `/shopping-list`, `/v2`) traktujemy jak start z `/`.
// Działa tylko przy pierwszej nawigacji; powrót z tła obsługuje
// plugins/launcher-resume.client.ts.
// Skrót z ikony aplikacji (`?shortcut=…`, nuxt.config) prowadzi prosto do celu.
import { claimLauncherShow, isStandalone, launcherEnabled } from '@/composables/useLauncher.js'

const START_PATHS = ['/', '/v2', '/shopping-list']

let firstNavigation = true

export default defineNuxtRouteMiddleware((to) => {
    if (!firstNavigation) return
    firstNavigation = false

    if (!isStandalone() || to.query.shortcut || !START_PATHS.includes(to.path)) return

    const target = launcherEnabled() && claimLauncherShow() ? '/start' : '/'
    if (to.path !== target) return navigateTo(target, { replace: true })
})
